export default __webpack_public_path__ + "static/media/frame_vi_pc.4043cfc2.png";